export default "assets/images/simple-form-background-3e7e7424.jpg";